import Radio from './src/radio';

Radio.install = function(Vue) {
  Vue.component(Radio.name, Radio);
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/radio/index.js